import { useEffect, useState } from "react";
import { debounce } from "lodash";
import { DirectionsResponse } from "../model/shema";
import { useDirections } from "..";
import { useQuery } from "react-query";

interface useGetAllDirectionsForSelectLazyIProps {
  initialData?: DirectionsResponse[];
  ActualOn?: string;
}

export const useGetAllDirectionsForSelectLazy = (
  options?: useGetAllDirectionsForSelectLazyIProps
) => {
  const { directionsGet } = useDirections();
  const [searchText, setSearchText] = useState("");
  const [actualOn, setActualOn] = useState(options?.ActualOn || "");

  const { data, isLoading, error, refetch } = useQuery(
    ["allDirectionsForSelectLazy", searchText, actualOn],
    async () => {
      const result = await directionsGet({
        name: searchText,
        ActualOn: actualOn,
      });

      if (!result?.data?.items) {
        throw new Error("Failed to fetch directions");
      }
      return {
        items: result.data.items,
      };
    },
    {
      initialData: options?.initialData
        ? { items: options.initialData }
        : undefined,
    }
  );

  useEffect(() => {
    refetch();
  }, [searchText, actualOn, refetch]);

  const debouncedSearchText = debounce((text: string) => {
    setSearchText(text);
  }, 300);

  const directions = data?.items
    ? data.items.map((direction: DirectionsResponse) => ({
        value: direction.instanceId,
        label: direction.name,
      }))
    : [];

  directions.unshift({ value: undefined, label: "Не выбрано" });

  const updateActualOn = (newActualOn: string) => {
    setActualOn(newActualOn);
  };

  return {
    directions,
    searchText: debouncedSearchText,
    isLoading,
    error,
    updateActualOn,
  };
};
